/**
 * manifest.js
 */

// === Global settings ===
import ('./core/base/_base.scss')
import ('./core/modules/_modules.scss')
import ('./core/header/_header.scss')
import ('./core/header/header').then(module => module.default.init())
import ('./core/footer/_footer.scss')

// == Components ==
import('./components/button/_button.scss')
import('./components/button/_buttons.scss')
import('./components/background-image/_background-image.scss')
import('./components/textfield/_textfield.scss')
import('./components/signup/_signup.scss')
import('./components/signup/signup').then(module => module.default.init())
import('./components/inline-signup/_inline-signup.scss')
import('./components/social-links/_social-links.scss')

// === Partials ===
import('./partials/tease--endorsement/_tease--endorsement.scss')
import('./partials/tease--issue/_tease--issue.scss')

// === Modules ===
import('./modules/hero/_hero.scss')
import('./modules/content/_content.scss')
import('./modules/twitter/_twitter.scss')
import('./modules/endorsements/_endorsements.scss')
import('./modules/photo_collage/_photo-collage.scss')
import('./modules/archive__endorsements/_archive__endorsements.scss')
import('./modules/archive__issues/_archive__issues.scss')
import('./modules/embed/_embed.scss')
import('./modules/embed/embed').then(module => module.default.init())
import('./modules/donate_footer/_donate_footer.scss')
import('./modules/donate_footer/donate_footer').then(module => module.default.init())
import('./modules/youtube/_youtube.scss')

// === Templates ===
import('./templates/page/_page.scss')
import('./templates/404/_404.scss')
